import { LandingMobileMenuSheet } from '@/shared/ui/kit/landing-mobile-menu-sheet';
import cn from 'classnames';
import { HTMLAttributes, ReactNode } from 'react';
import { UserProfile } from '@/entities/user-profile';
import { HeaderActionsLanding } from '@/shared/ui/kit/header-actions';
import { HeaderNavigation } from '@/shared/ui/kit/header-navigation';
import { LandingFooter } from '@/shared/ui/kit/landing-footer';
import { Header } from '@/shared/ui/kit/header';
import styles from './landing-shell.module.scss';


type LandingShellProps = {
    children: ReactNode;
    profile: UserProfile | null;
} & HTMLAttributes<HTMLDivElement>


export function LandingShell ({
    className,
    children,
    profile,
}: LandingShellProps) {
    return (
        <div
            className={ cn(styles.root, className) }
            data-template="landing-shell"
        >
            <Header
                profile={ profile }
                HeaderMobileMenuSheet={ LandingMobileMenuSheet }
                HeaderNavigation={ HeaderNavigation }
                HeaderActions={ HeaderActionsLanding }
            />

            <main className={ styles.main }>
                { children }
            </main>

            <LandingFooter/>
        </div>
    );
}
